// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"3b03c099","315":"aef0167f","381":"c0a8b961","389":"6812d007","453":"212e108b","591":"089fa0eb","707":"1a0844b2","794":"25a8e432","906":"781f4dc2"}[chunkId] + ".chunk.js";
};